// extracted by mini-css-extract-plugin
module.exports = {"company-profile":"company-profile___36fNP","mobile-body-box":"mobile-body-box___2xCI2","progress-box":"progress-box___3tncW","mobile-body":"mobile-body___2JQ07"};